export default "__VITE_ASSET__OPoAclYb__"